import { render, staticRenderFns } from "./EnergyPerformanceTab.vue?vue&type=template&id=96eded5c&scoped=true"
import script from "./EnergyPerformanceTab.vue?vue&type=script&lang=js"
export * from "./EnergyPerformanceTab.vue?vue&type=script&lang=js"
import style0 from "./EnergyPerformanceTab.vue?vue&type=style&index=0&id=96eded5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eded5c",
  null
  
)

export default component.exports